import { render, staticRenderFns } from "./ModalStartSettings.vue?vue&type=template&id=2d5b1fd6&scoped=true&"
import script from "./ModalStartSettings.vue?vue&type=script&lang=js&"
export * from "./ModalStartSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalStartSettings.vue?vue&type=style&index=0&id=2d5b1fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b1fd6",
  null
  
)

export default component.exports